var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4402 17.5C14.5557 17.5 12.6625 17.0618 10.7605 16.1855C8.85867 15.3092 7.10967 14.073 5.5135 12.477C3.92383 10.8808 2.69083 9.13333 1.8145 7.2345C0.938167 5.33583 0.5 3.44425 0.5 1.55975C0.5 1.25975 0.6 1.00808 0.8 0.80475C1 0.601583 1.25 0.5 1.55 0.5H4.8115C5.064 0.5 5.28675 0.582417 5.47975 0.74725C5.67275 0.911917 5.7955 1.11542 5.848 1.35775L6.42125 4.3C6.46092 4.573 6.45258 4.80758 6.39625 5.00375C6.33975 5.19992 6.23842 5.36467 6.09225 5.498L3.78275 7.74625C4.15442 8.42692 4.57908 9.07083 5.05675 9.678C5.53425 10.285 6.05125 10.8647 6.60775 11.4173C7.15642 11.9661 7.73975 12.4757 8.35775 12.9462C8.97575 13.4167 9.64308 13.8546 10.3598 14.2598L12.6038 11.9963C12.7603 11.8334 12.9498 11.7192 13.1723 11.6538C13.3946 11.5884 13.6257 11.5724 13.8655 11.6058L16.6423 12.1713C16.8948 12.2379 17.1008 12.3667 17.2605 12.5577C17.4202 12.7487 17.5 12.9654 17.5 13.2078V16.45C17.5 16.75 17.3984 17 17.1952 17.2C16.9919 17.4 16.7402 17.5 16.4402 17.5Z",
    fill: "#9B1E26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ab3a4712ebd772efcdea028a2dd8a1a2.svg";
export { ForwardRef as ReactComponent };